module.exports = __webpack_public_path__ + "static/media/icon_exit.cfcbd627.svg";